"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _units = require("../../theme/units");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "Center__Wrapper",
  componentId: "icheo6-0"
})(function (_ref) {
  var _theme$globalSizes$gu, _theme$globalSizes$gu2;

  var maxWidth = _ref.maxWidth,
      andText = _ref.andText,
      gutters = _ref.gutters,
      intrinsic = _ref.intrinsic,
      theme = _ref.theme;
  return (0, _styledComponents.css)(["box-sizing:content-box;margin-left:auto;margin-right:auto;", " ", " ", " ", ""], maxWidth && (0, _styledComponents.css)(["max-width:", ";"], maxWidth), andText && (0, _styledComponents.css)(["text-align:center;"]), intrinsic && (0, _styledComponents.css)(["display:flex;flex-direction:column;align-items:center;"]), gutters && (0, _styledComponents.css)(["padding-left:", ";padding-right:", ";"], (_theme$globalSizes$gu = theme.globalSizes[gutters]) !== null && _theme$globalSizes$gu !== void 0 ? _theme$globalSizes$gu : gutters, (_theme$globalSizes$gu2 = theme.globalSizes[gutters]) !== null && _theme$globalSizes$gu2 !== void 0 ? _theme$globalSizes$gu2 : gutters));
});
/**
 * The `Center` component is used to (you'll never guess) *centre* things - it has a couple of tricks up its sleeve however...
 *
 * By default it simply adds` margin-left:auto` & `margin-right:auto` onto a `div` element, but some other behaviour is worth considering.
 *
 * By setting the `intrinsic` prop, then the contents of the Center will be centered only if they have a width which is narrower than their parent (it does this by setting up a flex column with align-items set to center).
 *
 * A `Center` is **NOT** a `Box` underneath - it's only job is to center stuff inside it - not to all the stuff that Boxes do like being other elements etc. A Center **does not take padding** - it has `gutters` instead (see below)
 *
 * In order for it to do its centering thing it needs to use the `content-box` model (rather then the `border-box` model that `Boxes`, `Stacks` etc use)  - if you want it to be a Box, put a Box inside it :-)
 *
 */


var Center = function Center(_ref2) {
  var _ref2$andText = _ref2.andText,
      andText = _ref2$andText === void 0 ? false : _ref2$andText,
      children = _ref2.children,
      className = _ref2.className,
      _ref2$gutters = _ref2.gutters,
      gutters = _ref2$gutters === void 0 ? 'none' : _ref2$gutters,
      _ref2$intrinsic = _ref2.intrinsic,
      intrinsic = _ref2$intrinsic === void 0 ? false : _ref2$intrinsic,
      _ref2$maxWidth = _ref2.maxWidth,
      maxWidth = _ref2$maxWidth === void 0 ? _units.globalSizes.measure : _ref2$maxWidth,
      props = _objectWithoutProperties(_ref2, ["andText", "children", "className", "gutters", "intrinsic", "maxWidth"]);

  return /*#__PURE__*/_react["default"].createElement(Wrapper, _extends({
    andText: andText,
    className: className,
    gutters: gutters,
    intrinsic: intrinsic,
    maxWidth: maxWidth
  }, props), children);
};

var _default = Center;
exports["default"] = _default;